import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import DashboardListCard from 'modules/common/dashboard/DashboardListCard';
import SocialAmeliorationContainer from './containers/SocialAmeliorationContainer';
import * as actions from './action';
import * as c from './constant';

function TransactionsContainer({ totalStats, getTotalStats }) {
  const returnSeniorTransactionData = () => {
    const data = _.get(totalStats, 'item');
    return {
      label: 'Senior Citizen',
      total: _.get(data, '0.total', 0),
      list: [
        {
          label: 'Recorded',
          value: _.get(data, '0.total', 0),
          borderClassName: 'paid',
        },
        // {
        //   label: 'Pending',
        //   value: _.get(data, 'PENDING', 0),
        //   borderClassName: 'waiting',
        // },
        // {
        //   label: 'Rejected',
        //   value: _.get(data, 'REJECTED', 0),
        //   borderClassName: 'checking',
        // },
      ],
    };
  };
  const returnPWDTransactionData = () => {
    const data = _.get(totalStats, 'item');
    return {
      label: 'PWD',
      total:  _.get(data, '1.total', 0),
      list: [
        {
          label: 'Recorded',
          value:  _.get(data, '1.total', 0),
          borderClassName: 'paid',
        },
        // {
        //   label: 'Pending',
        //   value: _.get(data, 'PENDING', 0),
        //   borderClassName: 'waiting',
        // },
        // {
        //   label: 'Rejected',
        //   value: _.get(data, 'REJECTED', 0),
        //   borderClassName: 'checking',
        // },
      ],
    };
  };
  const returnStudentTransactionData = () => {
    const data = _.get(totalStats, 'item');
    return {
      label: 'Student',
      total:  _.get(data, '2.total', 0),
      list: [
        {
          label: 'Recorded',
          value:  _.get(data, '2.total', 0),
          borderClassName: 'paid',
        },
        // {
        //   label: 'Pending',
        //   value: _.get(data, 'PENDING', 0),
        //   borderClassName: 'waiting',
        // },
        // {
        //   label: 'Rejected',
        //   value: _.get(data, 'REJECTED', 0),
        //   borderClassName: 'checking',
        // },
      ],
    };
  };
  const returnSingleParentTransactionData = () => {
    const data = _.get(totalStats, 'item');
    return {
      label: 'Solo Parent',
      total:  _.get(data, '3.total', 0),
      list: [
        {
          label: 'Recorded',
          value:  _.get(data, '3.total', 0),
          borderClassName: 'paid',
        },
        // {
        //   label: 'Pending',
        //   value: _.get(data, 'PENDING', 0),
        //   borderClassName: 'waiting',
        // },
        // {
        //   label: 'Rejected',
        //   value: _.get(data, 'REJECTED', 0),
        //   borderClassName: 'checking',
        // },
      ],
    };
  };
  useEffect(() => {
    getTotalStats();
  }, []);

  return (
    <div className="container-fluid mb-3">
      <div className="row">
        <div className="col-4 pl-0">
          <DashboardListCard
            data={returnSeniorTransactionData()}
            className="mb-3"
          />
          <DashboardListCard
            data={returnPWDTransactionData()}
            className="mb-3"
          />
          <DashboardListCard
            data={returnSingleParentTransactionData()}
            className="mb-3"
          />
          <DashboardListCard
            data={returnStudentTransactionData()}
            className="mb-3"
          />
        </div>
        <div className="col-8 pr-0">
          <SocialAmeliorationContainer />
        </div>
      </div>
    </div>
  );
}

TransactionsContainer.propTypes = {
  totalStats: PropTypes.instanceOf(Object).isRequired,
  getTotalStats: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  totalStats: _.get(api, `${c.GET_TOTAL_STATS}`) || {},
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(TransactionsContainer);
